import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GestionFormModule } from "../../../../../../core/components/gestion-form/gestion-form.module";
import { ModalVehicleComponent } from "./modal-vehicle.component";


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        GestionFormModule
    ],
    declarations: [
        ModalVehicleComponent
    ],
    exports: [
        ModalVehicleComponent
    ]
})
export class ModalVehicleGestionFormModule { }
